module.exports = __webpack_public_path__ + "img/bg-nw-1.3da4a8a9.jpg";